export const getApiError = (error: unknown) => {
    if (!error) return 'Uknown error';

    if (error instanceof Error) {
        return error.message
    }

    return 'Uknown error';
}